import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const RihalOffers = () => {
  const offers = [
    {
      id: 1,
      title: 'أنشئ رحلتك الخاصة',
      description: 'خطط لرحلتك المثالية إلى أي وجهة.',
      link: '/CreateYourOwnTrip',
    },
    {
      id: 2,
      title: 'أنشئ رحلة للنساء',
      description: 'رحلات خاصة تم إعدادها حصريًا للنساء.',
      link: '/CreateATripForWomen',
    },
    {
      id: 3,
      title: 'شريك مرشدي السياح',
      description: 'استأجر مرشدين سياحيين خبراء لرحلاتك.',
      link: '/tourist-guides-agency',
    },
    {
      id: 4,
      title: 'دورات تدريبية وتكوين مرشدي السياح',
      description: 'تعلم كيف تصبح مرشدًا سياحيًا محترفًا.',
      link: '/tourist-guides-courses-and-formation',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 via-green-100 to-purple-100 flex flex-col items-center justify-center">
      <h1 className="text-5xl font-extrabold text-gray-800 mb-8">عروض رحال</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-11/12 lg:w-2/3">
        {offers.map((offer) => (
          <motion.div
            key={offer.id}
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">{offer.title}</h2>
            <p className="text-gray-600 mb-4">{offer.description}</p>
            <Link
              to={offer.link}
              className="inline-block bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition"
            >
              استكشف
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RihalOffers;
